export const API:string = process.env.REACT_APP_API || 'http://localhost:8080';